/* eslint-disable import/prefer-default-export */

import creator from './creator';
import {
  TAG_FETCH_START,
  TAG_FETCH_END,
  TAG_FETCH_MORE_START,
  TAG_FETCH_MORE_END,
 } from '../constants';

// 初始化
export const tagFetchStart = creator(TAG_FETCH_START, 'id')
export const tagFetchEnd = creator(TAG_FETCH_END, 'data')
export function tagFetch(id, ptag) {
  return async function tagFetchAction(dispatch, getState, { ds }) {
    dispatch(tagFetchStart())
    const resp = await ds.tag(id, ptag)
    const { data } = await resp.json()
    dispatch(tagFetchEnd(data || {}))
  }
}

// 获取更多
export const tagFetchMoreStart = creator(TAG_FETCH_MORE_START, 'tag', 'rank')
export const tagFetchMoreEnd = creator(TAG_FETCH_MORE_END, 'data')
export function tagFetchMore(tag, rank) {
  return async function tagFetchAction(dispatch, getState, { ds }) {
    dispatch(tagFetchMoreStart(tag, rank))
    const resp = await ds.tagMore(tag, rank)
    const { data } = await resp.json()
    dispatch(tagFetchMoreEnd(data))
  }
}



// WEBPACK FOOTER //
// ./src/actions/tag.js